import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ModuleId } from '@intellio/shared/models';
import {
  MODULE_CONFIGS_FEATURE_KEY,
  ModuleConfigsState,
} from './module-configs.reducer';

export const getModuleConfigsState =
  createFeatureSelector<ModuleConfigsState>(
    MODULE_CONFIGS_FEATURE_KEY
  );

export const getConfigs = (moduleId: ModuleId) =>
  createSelector(
    getModuleConfigsState,
    (state: ModuleConfigsState) => state?.configs?.get(moduleId)
  );

export const getConfigsLoaded = (moduleId: ModuleId) =>
  createSelector(
    getModuleConfigsState,
    (state: ModuleConfigsState) => state?.loaded?.get(moduleId)
  );

export const getConfigsLoading = (moduleId: ModuleId) =>
  createSelector(
    getModuleConfigsState,
    (state: ModuleConfigsState) => state?.loading?.get(moduleId)
  );

export const getError = createSelector(
  getModuleConfigsState,
  (state: ModuleConfigsState) => state?.error
);
